
import { gsap } from 'gsap'
import headerInit from './header';
import 'slick-carousel'

jQuery(function() {
  let $ = jQuery;
  let windowWidth = window.innerWidth
  let itemWidth = $('.carousel-item:nth-child(2)').outerWidth(true)
  let carouselNavigation = $('.carousel-navigation')

  headerInit($, '#000')

  gsap.to('h1', { '--clip': '0%', duration: .4 }, 1.5)

  $('.carousel').slick({
    dots: true,
    appendDots: '.carousel-navigation',
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    infinite: false,
  });

  // hide the header logo on scroll down and show it on up
  function scrollHandler() {
    if ($(window).scrollTop() <= 20) {
      gsap.to('#header-logo', {autoAlpha: 1, duration: 0.3})
    } else {
      gsap.to('#header-logo', {autoAlpha: 0, duration: 0.3})
    }
  }
  document.addEventListener('scroll', scrollHandler)

  // scroll to top
  $('#back-to-top').on('click', () => {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
    return false;
  })

  // on load more listener
  $('#load_more').on('click', () => {
    var button = $('#load_more'),
    data = {
      'action': 'loadmore',
      'query': NEWSROOM_AJAX.posts,
      'page' : NEWSROOM_AJAX.current_page
    };

    $.ajax({
      url : NEWSROOM_AJAX.ajax_url,
      data : data,
      type : 'POST',
      beforeSend : function () {
        button.text('Loading...');
      },
      success : function( data ){
        if( data ) { 
          button.text( 'Load more' ).before(data)
          NEWSROOM_AJAX.current_page++;

          if ( NEWSROOM_AJAX.current_page == NEWSROOM_AJAX.max_page ) 
          button.remove(); // if last page, remove the button
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });

});
